import {combineReducers} from 'redux';
import {currentGroup} from './reducers/current-group';
import {headerUiState} from './reducers/header-ui';
import {currentUser} from './reducers/current-user';
import {siteModalsBootstrap} from '../lib/site-modals/site-modal';

export default combineReducers({
  currentGroup,
  headerUiState,
  currentUser,
  ...siteModalsBootstrap.reducer
});
